var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVectorAssets05(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 360 360",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#6cb706;}.cls-2{fill:#006e8b;}.cls-3{fill:#90d12a;}.cls-4{fill:#6acee5;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    className: "cls-1",
    d: "M195.8,173.7H156a55.1,55.1,0,0,0-15.7,1.5,6.3,6.3,0,0,0-3.4,2.2c-.9,1.5-.3,3.4.1,5.1,2.7,9.6,3,19.7,4.4,29.6s4.1,20.1,10.7,27.6a5,5,0,0,0,2.4,1.9,5.8,5.8,0,0,0,3.2,0c11.1-2.4,21.1-8.4,30.9-14.3a14.9,14.9,0,0,0,8.8-11.6c3.1-11.4,6.1-23.1,4.5-34.7-.5-3-2.4-6.8-5.4-6.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    className: "cls-2",
    d: "M169.9,97.4s17.5,35.8,67.5,43c16.6,2.2,35-5.7,35-5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    className: "cls-3",
    d: "M189.6,195.9c-7.8,12.1,2.8,28.3-.1,42.5-1.2,5.5-3.9,12.7.9,15.9,3.2,2.2,8,.1,10-3.3s2.3-7.5,2.6-11.4a119.2,119.2,0,0,1,14-47c4-7.4,8.9-15.7,6.3-23.7-3.1-9.6-14.9-12.7-24.9-14-6.4-.9-13.3-1.6-19.2,1.1-8,3.5-12.4,11.9-16.5,19.6A326.8,326.8,0,0,1,106,252.5a3.4,3.4,0,0,0-1.4,2.1c-.3,1.3.9,2.6,2.1,3.3,4.7,2.9,11,2.1,15.8-.7s8.5-7.1,12.1-11.4c11-12.9,22.3-25.6,34.1-37.9,5.9-6.2,12.6-12.7,21.2-13.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    className: "cls-3",
    d: "M183.1,166.1c14.3-18.7,20.9-42.1,30.2-63.7a2.6,2.6,0,0,1,2.9-2.2,1.8,1.8,0,0,1,1,.4c9.7,3.6,19.1,7.7,28.4,12.2a48.5,48.5,0,0,0-8,8.9c-3.4,4.6-6.1,9.7-9.3,14.5a148.7,148.7,0,0,1-12.6,16.1l-12.1,14.3a7.5,7.5,0,0,1-2.5,2.2,7.8,7.8,0,0,1-4,.2,71,71,0,0,1-16.4-4.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    className: "cls-4",
    d: "M272.4,134.7c-4.3-3.3-102.5-37.3-102.5-37.3L239.9,0h95.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    className: "cls-3",
    d: "M199.4,159.9l-30.6.3c-4.7.1-9.8.2-13.5,3.1s-5.7,10.8-6.4,16.9a156.4,156.4,0,0,1-10.4,39.9c9.3-7.7,18.6-15.5,26.3-24.8,3.3-3.9,6.3-8.2,10.2-11.6s9.4-6.1,14-9.3,9-7.4,10.3-12.9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorAssets05);
export default __webpack_public_path__ + "static/media/Vector Assets-05.ead8dfdb760b9b42482ae683749d4d48.svg";
export { ForwardRef as ReactComponent };